<div
  class="add-task-container"
  [formGroup]="form"
>
  <mojo-editor
    [showCandidateMentionTags]="true"
    [showUserMentionForTasks]="true"
    [hasTalentPoolFeatureExtension]="talentPoolsService.hasTalentPoolPrivilegeAndFe() | async"
    [hasAnonymization]="hasAnonymization$ | async"
    formControlName="description"
    [placeholder]="'Task description'"
    [maxLength]="255"
    material="true"
    [footerPaddingXl]="true"
    toolbar=""
  >
    <div class="task-editor-footer">
      <div class="display-flex">
        <div
          class="due-date-wrapper"
          (click)="picker.open()"
        >
          <mat-icon
            [ngClass]="{'date-picked': form.controls.date.value !== null}"
            class="calendar-icon"
          >event</mat-icon>
          <span>{{getFormat(datePickerInput.value) || 'Due date'}}</span>
          <input
            #datePickerInput
            class="date-input"
            matInput
            [matDatepicker]="picker"
            [min]="today"
            formControlName="date"
          >
          <mat-datepicker
            #picker
            (opened)="datePickerChangedState.emit(true)"
            (closed)="datePickerChangedState.emit(false)"
          ></mat-datepicker>
        </div>

        <div
          class="due-date-wrapper margin-left-10"
          [matMenuTriggerFor]="menu"
          #assignedMenuTrigger="matMenuTrigger"
          [matTooltip]="longName"
          [matTooltipDisabled]="disabledToolTip"
          (menuOpened)="datePickerChangedState.emit(true)"
          (menuClosed)="datePickerChangedState.emit(false)"
        >
          <mat-icon
            class="calendar-icon"
            [ngClass]="{'date-picked': getName() !== 'Assign'}"
          >person_add</mat-icon>
          <span>{{getName()}}</span>

        </div>
      </div>
      <button
        mat-button
        class="m-rounded m-center send-button"
        (click)="createTask()"
        [disabled]="!form?.valid"
      >
        <mat-icon
          color="primary"
          class="small-icon"
        >send</mat-icon>
      </button>
    </div>
  </mojo-editor>

  <mat-menu #menu="matMenu">
    <mojo-candidate-input
      (click)="$event.stopPropagation()"
      [width]="width"
      [label]="'Search members'"
      [form]="formUser"
      (selectOption)="assignedMenuTrigger.closeMenu()"
      controlName="userInput"
    ></mojo-candidate-input>
  </mat-menu>
</div>
